/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 9/6/22
 */
import React, {memo, useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'antd';
import {DeleteOutlined} from '@ant-design/icons';
import classNames from 'classnames';
import {useTranslation} from 'react-i18next';
import styles from './index.less';
import Editor from '@/components/Editor';

const GlobalNote = ({note, onSave, onCancel, onRemove,  question}) => {
  const [value, setValue] = useState(note);

  const {t} = useTranslation('templates');

  const onChange = useCallback((e) => {
    setValue(e?.target?.value);
  }, []);

  const onSubmit = useCallback(() => {
    onSave(value);
  }, [onSave, value]);

  const handleCancel = useCallback(() => {
    setValue(note);
    onCancel?.();
  }, [onCancel, note]);
  
  const handleRemove = useCallback(() => {
    onRemove?.();
    setValue('');
  }, [onRemove]);

  return (
    <div className="w-full">
      <div className={classNames('custom-form-big', styles.wrapperInput)}>
        <div className="custom-form-big">
          <Editor
            key={question?._id}
            value={value}
            onChange={onChange}
            onPressEnter={onSubmit}
            onBlur={onSubmit}/>
        </div>
        {/*<Input size="large" value={value} onChange={onChange}/>*/}
      </div>

      <div className={classNames('gap-2 py-2 flex items-center justify-between', styles.wrapperButtons)}>
        <div className="flex gap-2">
          <Button size="large" type="primary" className="custom-btn border-rounded-5"
            onClick={onSubmit}>{t('globalNote.save')}</Button>
          <Button size="large" className="custom-btn" onClick={handleCancel}>{t('globalNote.cancel')}</Button>
        </div>

        <div className="flex gap-2">
          <Button
            onClick={handleRemove}
            type="dashed"
            shape="circle"
            icon={<DeleteOutlined />}
            danger
            style={{ borderRadius: '50%' }}
          />
        </div>
      </div>
    </div>
  );
};

GlobalNote.propTypes = {
  note: PropTypes.string,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onRemove: PropTypes.func,
  question: PropTypes.object
};

export default memo(GlobalNote);
